function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['tables_views']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/tables_views';
var DOMAIN_ASSIGNMENTS = '/resources';
export default {
  getResources: function getResources(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getResources(data);
      });
    });
  }
};